<mat-spinner *ngIf="isLoading" diameter="50"></mat-spinner>
<mat-error *ngIf="hasError">
  {{ errorMessage }}
</mat-error>
<app-blocks-workflow [blocks]="blocks"
                     [models]="subModels"
                     [context]="context"
                     (workflowComplete)="onWorkflowComplete($event)"></app-blocks-workflow>
